import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { literalValueTypes } from "../../primitives";
import { idValidator } from "../misc/id-validator";
export const stateValueValidator = T.model("state", T.object({
    typeName: T.literal("state_value"),
    id: idValidator("state_value"),
    // path: T.string,
    value: literalValueTypes
}));
export const SWStateValueRecordType = createRecordType("state_value", {
    migrations: defineMigrations({}),
    validator: stateValueValidator,
    scope: "session"
});
export function isStateValue(record) {
    if (!record) return false;
    return record.typeName === "state_value";
}
export function isStateValueId(id) {
    if (!id) return false;
    return id.startsWith("state_value:");
}
/** @public */ export function createStateValueId(id) {
    return `state_value:${id ?? nanoid()}`;
}
export function createStateValue(stateValue) {
    return {
        ...stateValue,
        id: createStateValueId(stateValue.id)
    };
}
